/* Four Branches — header behaviour on every page (mobile menu, dropdowns). Loaded by theme.liquid and fb-home.liquid. */
(function () {
  if (window.__fbChrome) return;
  window.__fbChrome = true;
  var root = document.documentElement;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* Mobile / tablet menu overlay */
    document.querySelectorAll('[data-fb-menu-open]').forEach(function (btn) {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;
      var closeBtn = menu.querySelector('[data-fb-menu-close]');
      function open() {
        menu.classList.add('is-open');
        menu.removeAttribute('inert');
        menu.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        root.classList.add('fb-menu-open');
        if (closeBtn) closeBtn.focus();
      }
      function close() {
        menu.classList.remove('is-open');
        menu.setAttribute('inert', '');
        menu.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
        root.classList.remove('fb-menu-open');
        btn.focus();
      }
      btn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
      /* accordion for child links */
      menu.querySelectorAll('.fb-menu__caret').forEach(function (c) {
        c.addEventListener('click', function () {
          var sub = document.getElementById(c.getAttribute('aria-controls'));
          var openNow = c.getAttribute('aria-expanded') !== 'true';
          c.setAttribute('aria-expanded', openNow ? 'true' : 'false');
          if (sub) sub.hidden = !openNow;
        });
      });
    });

    /* Desktop dropdowns: hover/focus via CSS; caret button toggles for click/touch/keyboard */
    var items = document.querySelectorAll('[data-fb-dropdown]');
    function closeAll(except) {
      items.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = li.querySelector('.fb-header__caret');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (li) {
      var b = li.querySelector('.fb-header__caret');
      if (!b) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var openNow = !li.classList.contains('is-open');
        closeAll(li);
        li.classList.toggle('is-open', openNow);
        b.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); b.focus(); }
      });
      li.addEventListener('mouseleave', function () {
        li.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-fb-dropdown]')) closeAll();
    });
  });
})();
